export function useBetFiltersValidation() {
    const { t } = useI18n();

    const validateCorrectScore = (value: string | null): boolean | string => {
        if (!value) return true;
        const pattern = /^(\d{1,2})-(\d{1,2})$/;
        const match = value.match(pattern);

        if (!match) {
            return t('rules.correctScoreFormat');
        }

        const home = parseInt(match[1]);
        const away = parseInt(match[2]);

        if (isNaN(home) || isNaN(away) || home < 0 || home > 99 || away < 0 || away > 99) {
            return t('rules.correctScoreFormat');
        }

        return true;
    };

    const isCorrectScoreValid = (value: string | null): boolean => {
        return validateCorrectScore(value) === true;
    };

    const formatCorrectScoreInput = (event: Event, updateValue?: (value: string | null) => void): string | null => {
        const input = event.target as HTMLInputElement;
        let value = input.value;

        value = value.replace(/[^\d-]/g, '');

        const parts = value.split('-');
        if (parts.length > 2) {
            value = parts[0] + '-' + parts.slice(1).join('');
        }

        const scoreParts = value.split('-');
        if (scoreParts[0]) {
            let home = parseInt(scoreParts[0]) || 0;
            if (home > 99) home = 99;
            scoreParts[0] = home.toString();
        }
        if (scoreParts.length > 1 && scoreParts[1]) {
            let away = parseInt(scoreParts[1]) || 0;
            if (away > 99) away = 99;
            scoreParts[1] = away.toString();
        }

        value = scoreParts.join('-');
        input.value = value;

        const finalValue = value || null;
        if (updateValue) {
            updateValue(finalValue);
        }

        return finalValue;
    };

    const getHandicapRules = () => [
        (v: number | null): boolean | string => {
            if (v === null) return true;
            if (isNaN(+v)) return t('rules.number');
            if ((+v * 4) % 1 !== 0) {
                return t('rules.multipleOf', { value: '0.25' });
            }
            return true;
        },
    ];

    const isHandicapValid = (value: number | null): boolean => {
        return value == null || (!isNaN(+value) && (+value * 4) % 1 === 0);
    };

    const handicapRules = computed(() => getHandicapRules());

    return {
        validateCorrectScore,
        isCorrectScoreValid,
        formatCorrectScoreInput,
        getHandicapRules,
        isHandicapValid,
        handicapRules,
    };
}
